import { MobileView, } from 'react-device-detect';
import Toolbar from '@mui/material/Toolbar';

import NavbarMobileBottom from './NavbarMobileBottom';

export default function NavbarFooter() {
    return (
        <MobileView>
            <Toolbar />
            <footer>
                <NavbarMobileBottom />
            </footer>
        </MobileView>
    )
}
